import React, { useEffect, useState } from 'react';
import '../masters/Users.scss'
import ReactPagination from "react-js-pagination";

const Pagination = ({setPageNo,setPageSize,pageSize,pageCount}) => {
  const [acticePage, setActicePage] = useState(null)
  const [paging, setPaging] = useState([])
    const handlePageClick =(e) => {
        setPageNo(e)
        setActicePage(e)
      }
      const handleRowSelect =(e) => {
       setPageNo(1)
       setPageSize(e.target.value)
      
      }
      useEffect(() => {
          let pager = []
          let pagecounter = []
          pager.push(Math.ceil(100 / pageSize))
          let setpagecount = []
        for (let i = 1;i<=pager;i++){
          setpagecount.push(i)
        }
        setpagecount.filter(page=>page<=5).map(pag=>pagecounter.push(pag))
        setPaging(pagecounter)
      }, [])
      
  return (
   <div>
       <div className="paginate">
            <div className="paginate_row">
              <span className='per-row' >Entries per page</span>
              <select value={pageSize}  onChange={handleRowSelect} name="rowselect" id="">
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </select>
            </div>
            <div className="paginate_nav">
               {pageCount!==null&&<ReactPagination
                activePage={acticePage}
                itemsCountPerPage={pageSize}
                totalItemsCount={pageCount}
                pageRangeDisplayed={2}
                prevPageText={<i className="fa-solid fa-chevron-left"></i>}
                firstPageText={<i className="fa-solid fa-angles-left"></i>}
                nextPageText={<i className="fa-solid fa-chevron-right"></i>}
                lastPageText={<i className="fa-solid fa-angles-right"></i>}
                onChange={handlePageClick}
                activeClass={"pageactive"}
                innerClass={"pagination"}
                itemClass={"pageItem"}
                disabledClass={"pageitemDisable"}
              />}
            </div>
            {/* {
              paging.map((data)=>(
                <span onClick={()=>onpagechange(data)}>{data}</span>
              ))
            } */}
          </div>
  </div>
  )
};

export default Pagination;
